import {
  Component,
  Input,
  OnChanges,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  SimpleChanges,
  ViewChild,
  inject,
} from '@angular/core';

/* import { BypassHTMLPipe } from '../../pipes/bypassHTML.pipe'; */
import { iconList as icons, IconKey } from '../../shared/icons';
import { isPlatformBrowser } from '@angular/common';

interface IconPartColoring {
  element: string;
  fill?: string;
  stroke?: string;
}
@Component({
  selector: 'icon-wrap',
  templateUrl: 'icon.component.html',
  standalone: true,
})
export class IconWrapComponent implements OnInit, OnChanges {
  @ViewChild('iconContainer', { static: true }) iconContainer!: {
    nativeElement: HTMLElement;
  };
  @Input() width!: string;
  @Input() height!: string;
  @Input({ required: true }) name!: IconKey;
  @Input() color!: string;
  @Input() parts!: IconPartColoring[];
  platformId = inject(PLATFORM_ID);
  isBrowser = isPlatformBrowser(this.platformId);
  constructor(private renderer: Renderer2) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (!this.isBrowser) return;
    const { name } = changes;
    if (name) {
      this.name = name.currentValue;
      this.setIcon();
    }
  }
  setIcon() {
    if (!this.name) {
      console.warn('Icon component NAME input is empty.');
      return;
    }
    const foundIcon = icons[this.name as keyof typeof icons];
    if (!foundIcon) {
      console.warn('No icon name found with: ' + this.name);
      return;
    }
    const parser = new DOMParser();
    const parsed = parser
      .parseFromString(foundIcon, 'image/svg+xml')
      .querySelector('svg');
    if (this.color) {
      parsed?.querySelectorAll('path').forEach((v) => {
        v.style.stroke = this.color;
      });
    }
    if (this.width) {
      parsed?.setAttribute('width', this.width);
    }
    if (this.height) {
      parsed?.setAttribute('height', this.height);
    }
    if (this.parts) {
      this.parts.forEach((p) => {
        parsed?.querySelectorAll(p.element).forEach((el: any) => {
          if (p.fill) {
            el.style.fill = p.fill;
          }
          if (p.stroke) {
            el.style.stroke = p.stroke;
          }
        });
      });
    }
    const x = new XMLSerializer();
    this.renderer.setProperty(
      this.iconContainer.nativeElement,
      'innerHTML',
      x.serializeToString(parsed as Node)
    );
  }

  ngOnInit() {}
}
